$('.load-more-events').on('click', function(e) {
    e.preventDefault();

    var load = $(this);
    load.html('<i class="fas fa-spinner fa-spin"></i>');

    var type = $('#rubrique-event').val();
    var page = parseInt($('#current-page').val());
    var pagemax = parseInt($('#max-page').val());
    var posts = parseInt($('#posts-page').val());

    jQuery.post(
        ajaxurl,
        {
            'action': 'load_more_events',
            'type': type,
            'page': page,
            'posts': posts
        },
        function(response){
            load.html('VOIR PLUS');
            page = page + 1;
            $('.row-events').append(response);
            $('.row-events .col-md-4.last').hide().fadeIn(1000);
            $('.row-events .col-md-4').removeClass('last');
            $('#current-page').val(page);

            if ( page == pagemax ) {
                $('.row-more').remove();
            }
        }
    );
});